import React from "react";
import CardBoard from "./CardBoard";

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <h1>あなたにいいねが届いています</h1>
        <CardBoard />
      </div>
    );
  }
}

export default App;
